export default __webpack_public_path__ + "static/media/content_tab03_2_02.157f8098.jpg";